import { getLocalAccessToken } from "../../utils/helper";
import api, { handleErrorCreateAndUpdate } from "../../services/api";
import { Toast } from "../../components/notify/Notify";
import { url } from "../../constants/path";
const accessToken = getLocalAccessToken();

api.defaults.headers.common["Authorization"] = "Bearer " + accessToken;

const URL = url.ttsColor;

/*  
   TTS Color
*/

export const createTTSColor = (data, callback) => {
  api
    .post(URL, data)
    .then((response) => {
      callback(response.data.data);
      Toast("success", "Thành công");
    })
    .catch((err) => {
      handleErrorCreateAndUpdate(err, callback);
    });
};

export const initTTSColor = (callback) => {
  api
    .post(`${URL}/bulk`)
    .then((response) => {
      callback(response.data.data);
      Toast("success", "Thành công");
    })
    .catch((err) => {
      handleErrorCreateAndUpdate(err, callback);
    });
};

export const getTTSColor = (params = {}, callback) => {
  api
    .get(URL, { params })
    .then((response) => callback(response.data.data))
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};

export const getTTSColorDetail = (id, callback) => {
  api
    .get(`${URL}/${id}`)
    .then((response) => callback(response.data.data))
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};

export const updateTTSColor = (id, data, callback) => {
  api
    .patch(`${URL}/${id}`, data)
    .then((response) => {
      callback(response.data.data);
      Toast("success", "Thành công");
    })
    .catch((err) => {
      handleErrorCreateAndUpdate(err, callback);
    });
};

//? remove iot partner
export const removeTTSColor = (id) => {
  api
    .delete(`${URL}/${id}`)
    .then((response) => Toast("success", "Thành công"))
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};
